import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../../styles/Global.css';
import '../../styles/CtdHome.css';
import HomeMenu from '../../components/HomeMenu';
import HomeButton from '../../components/HomeButton';

const Passporthowto = () => {
    return (
        <>
            <div className="home-container">
                <HomeMenu/>
                <Container>
                    <Row className="justify-content-md-center">

                        <Col md={12}>

                            <div className="">
                                <p className="innertext">PROCEDURE FOR PASSPORT APPLICATION</p>
                                <div className="buttongroup">
                                    <div className='howtogroup'>
                                        <div className="row my-auto">
                                            <div className="col-12">
                                                <p className="text-white howtotext">Please follow the following steps to make an online passport application:</p>
                                            </div>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 1:</span> Navigate to the passport portal.</p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 2:</span> Click the "Start New Application” link to start a new application.</p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 3:</span> Accept the terms and conditions displayed in the Disclaimer. </p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 4:</span> Answer simple security questions.</p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 5:</span> Complete the passport application form. </p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 6:</span> Print the Passport Application Payment Advice Form.</p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 7:</span> Make payments for the selected type of passport using the selected payment method. </p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 8:</span> Schedule an appointment for a date of your convenience using the “Schedule Appointment” link on the home page.</p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 9:</span> Print the Passport Application Appointment Form.</p>
                                            <p className="text-white howtotext"> <span className='howtobold'>Step 10:</span> Report to the selected passport center with the passport appointment form and the appropriate application requirements displayed on the website for enrollment.</p>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                </Container>
                
            </div>
            
            
        </>
    );
}


export default Passporthowto;